/**
 * Portal ICAVI - Serviço de domínio: Recepção
 * Extraído de apiService.ts para reduzir o tamanho do módulo monolítico (RF-07).
 */
import axios from 'axios';
import { api } from '../apiClient';
export const recepcaoServiceMethods = {
    async listarAlmocosDiario(params = {}) {
        try {
            const queryParams = new URLSearchParams();
            if (params.data_inicio)
                queryParams.append('data_inicio', params.data_inicio);
            if (params.data_fim)
                queryParams.append('data_fim', params.data_fim);
            if (params.empresa)
                queryParams.append('empresa', params.empresa);
            const url = `/api/recepcao/almocos-diario${queryParams.toString() ? '?' + queryParams.toString() : ''}`;
            const response = await api.get(url);
            return response.data;
        }
        catch (error) {
            console.error('Erro ao listar almoços diários:', error);
            if (axios.isAxiosError(error) && error.response?.data)
                return error.response.data;
            throw error;
        }
    },
    async listarLanchesRecepcao(params = {}) {
        try {
            const queryParams = new URLSearchParams();
            if (params.data_inicio)
                queryParams.append('data_inicio', params.data_inicio);
            if (params.data_fim)
                queryParams.append('data_fim', params.data_fim);
            if (params.empresa)
                queryParams.append('empresa', params.empresa);
            if (params.nome)
                queryParams.append('nome', params.nome);
            const url = `/api/recepcao/lanches${queryParams.toString() ? '?' + queryParams.toString() : ''}`;
            const response = await api.get(url);
            return response.data;
        }
        catch (error) {
            console.error('Erro ao listar lanches da recepcao:', error);
            if (axios.isAxiosError(error) && error.response?.data)
                return error.response.data;
            throw error;
        }
    },
    async buscarColaboradoresPorCatraca(data, options = {}) {
        try {
            const query = new URLSearchParams({ data });
            if (options.modo)
                query.set('modo', options.modo);
            if (options.dataLancheSexta)
                query.set('data_lanche_sexta', options.dataLancheSexta);
            const response = await api.get(`/api/recepcao/colaboradores-por-catraca?${query.toString()}`);
            return response.data;
        }
        catch (error) {
            console.error('Erro ao buscar colaboradores por catraca:', error);
            if (axios.isAxiosError(error) && error.response?.data)
                return error.response.data;
            throw error;
        }
    },
    async salvarLanchesSextaSolicitacoes(dados) {
        try {
            const response = await api.post('/api/recepcao/lanches-sexta/solicitacoes', dados);
            return response.data;
        }
        catch (error) {
            console.error('Erro ao salvar solicitações de lanche de sexta:', error);
            if (axios.isAxiosError(error) && error.response?.data)
                return error.response.data;
            throw error;
        }
    },
    async listarLanchesSextaSolicitacoes(params = {}) {
        try {
            const queryParams = new URLSearchParams();
            if (params.data_referencia)
                queryParams.append('data_referencia', params.data_referencia);
            if (params.data_inicio)
                queryParams.append('data_inicio', params.data_inicio);
            if (params.data_fim)
                queryParams.append('data_fim', params.data_fim);
            if (params.empresa_id !== undefined)
                queryParams.append('empresa_id', String(params.empresa_id));
            if (params.empresa_nome)
                queryParams.append('empresa_nome', params.empresa_nome);
            if (params.solicitou_lanche !== undefined)
                queryParams.append('solicitou_lanche', String(params.solicitou_lanche));
            if (params.colaborador_nome)
                queryParams.append('colaborador_nome', params.colaborador_nome);
            if (params.page !== undefined)
                queryParams.append('page', String(params.page));
            if (params.limit !== undefined)
                queryParams.append('limit', String(params.limit));
            const url = `/api/recepcao/lanches-sexta/solicitacoes${queryParams.toString() ? '?' + queryParams.toString() : ''}`;
            const response = await api.get(url);
            return response.data;
        }
        catch (error) {
            console.error('Erro ao listar solicitações de lanche de sexta:', error);
            if (axios.isAxiosError(error) && error.response?.data)
                return error.response.data;
            throw error;
        }
    },
    /** Empresas distintas no período (filtro pesquisável na tela de solicitações) */
    async listarEmpresasLanchesSextaPeriodo(params = {}) {
        try {
            const queryParams = new URLSearchParams();
            if (params.data_inicio)
                queryParams.append('data_inicio', params.data_inicio);
            if (params.data_fim)
                queryParams.append('data_fim', params.data_fim);
            const url = `/api/recepcao/lanches-sexta/solicitacoes/empresas${queryParams.toString() ? '?' + queryParams.toString() : ''}`;
            const response = await api.get(url);
            return response.data;
        }
        catch (error) {
            console.error('Erro ao listar empresas do período (lanches sexta):', error);
            if (axios.isAxiosError(error) && error.response?.data)
                return error.response.data;
            throw error;
        }
    },
    async listarResumoFechamentosLanchesSexta(params = {}) {
        try {
            const queryParams = new URLSearchParams();
            if (params.data_referencia)
                queryParams.append('data_referencia', params.data_referencia);
            if (params.data_inicio)
                queryParams.append('data_inicio', params.data_inicio);
            if (params.data_fim)
                queryParams.append('data_fim', params.data_fim);
            if (params.mes_fechamento)
                queryParams.append('mes_fechamento', params.mes_fechamento);
            if (params.data_fechamento_inicio)
                queryParams.append('data_fechamento_inicio', params.data_fechamento_inicio);
            if (params.data_fechamento_fim)
                queryParams.append('data_fechamento_fim', params.data_fechamento_fim);
            if (params.empresa_id !== undefined)
                queryParams.append('empresa_id', String(params.empresa_id));
            if (params.status_fechamento)
                queryParams.append('status_fechamento', params.status_fechamento);
            const url = `/api/recepcao/lanches-sexta/fechamentos/resumo${queryParams.toString() ? '?' + queryParams.toString() : ''}`;
            const response = await api.get(url);
            return response.data;
        }
        catch (error) {
            console.error('Erro ao listar resumo de fechamento de lanches sexta:', error);
            if (axios.isAxiosError(error) && error.response?.data)
                return error.response.data;
            throw error;
        }
    },
    async obterAlertaFechamentosMesAnterior() {
        try {
            const response = await api.get('/api/recepcao/notificacoes/fechamentos-mes-anterior');
            return response.data;
        }
        catch (error) {
            console.error('Erro ao buscar alerta de fechamentos do mês anterior:', error);
            if (axios.isAxiosError(error) && error.response?.data)
                return error.response.data;
            throw error;
        }
    },
    async criarFechamentoLanchesSexta(dados) {
        try {
            const response = await api.post('/api/recepcao/lanches-sexta/fechamentos', dados);
            return response.data;
        }
        catch (error) {
            console.error('Erro ao criar fechamento de lanches sexta:', error);
            if (axios.isAxiosError(error) && error.response?.data)
                return error.response.data;
            throw error;
        }
    },
    async detalharFechamentoLanchesSexta(fechamentoId) {
        try {
            const response = await api.get(`/api/recepcao/lanches-sexta/fechamentos/${fechamentoId}`);
            return response.data;
        }
        catch (error) {
            console.error('Erro ao detalhar fechamento de lanches sexta:', error);
            if (axios.isAxiosError(error) && error.response?.data)
                return error.response.data;
            throw error;
        }
    },
    async atualizarStatusFechamentoLanchesSexta(fechamentoId, dados) {
        try {
            const response = await api.put(`/api/recepcao/lanches-sexta/fechamentos/${fechamentoId}/status`, dados);
            return response.data;
        }
        catch (error) {
            console.error('Erro ao atualizar status do fechamento de lanches sexta:', error);
            if (axios.isAxiosError(error) && error.response?.data)
                return error.response.data;
            throw error;
        }
    },
    async reabrirFechamentoLanchesSexta(fechamentoId, dados = {}) {
        try {
            const response = await api.put(`/api/recepcao/lanches-sexta/fechamentos/${fechamentoId}/reabrir`, dados);
            return response.data;
        }
        catch (error) {
            console.error('Erro ao reabrir fechamento de lanches sexta:', error);
            if (axios.isAxiosError(error) && error.response?.data)
                return error.response.data;
            throw error;
        }
    },
    async excluirFechamentoLanchesSexta(fechamentoId) {
        try {
            const response = await api.delete(`/api/recepcao/lanches-sexta/fechamentos/${fechamentoId}`);
            return response.data;
        }
        catch (error) {
            console.error('Erro ao excluir fechamento de lanches sexta:', error);
            if (axios.isAxiosError(error) && error.response?.data)
                return error.response.data;
            throw error;
        }
    },
    async listarFechamentoRefeitorio(params = {}) {
        try {
            const queryParams = new URLSearchParams();
            if (params.data_inicio)
                queryParams.append('data_inicio', params.data_inicio);
            if (params.data_fim)
                queryParams.append('data_fim', params.data_fim);
            if (params.numero_nota_fiscal)
                queryParams.append('numero_nota_fiscal', params.numero_nota_fiscal);
            const url = `/api/recepcao/fechamento-refeitorio${queryParams.toString() ? '?' + queryParams.toString() : ''}`;
            const response = await api.get(url);
            return response.data;
        }
        catch (error) {
            console.error('Erro ao listar fechamento de refeitorio:', error);
            if (axios.isAxiosError(error) && error.response?.data)
                return error.response.data;
            throw error;
        }
    },
    async criarFechamentoRefeitorio(dados) {
        try {
            const response = await api.post('/api/recepcao/fechamento-refeitorio', dados);
            return response.data;
        }
        catch (error) {
            console.error('Erro ao criar fechamento de refeitorio:', error);
            if (axios.isAxiosError(error) && error.response?.data)
                return error.response.data;
            throw error;
        }
    },
    async atualizarFechamentoRefeitorio(id, dados) {
        try {
            const response = await api.put(`/api/recepcao/fechamento-refeitorio/${id}`, dados);
            return response.data;
        }
        catch (error) {
            console.error('Erro ao atualizar fechamento de refeitorio:', error);
            if (axios.isAxiosError(error) && error.response?.data)
                return error.response.data;
            throw error;
        }
    },
    async excluirFechamentoRefeitorio(id) {
        try {
            const response = await api.delete(`/api/recepcao/fechamento-refeitorio/${id}`);
            return response.data;
        }
        catch (error) {
            console.error('Erro ao excluir fechamento de refeitorio:', error);
            if (axios.isAxiosError(error) && error.response?.data)
                return error.response.data;
            throw error;
        }
    },
    async cadastrarAlmocoDiario(dados) {
        try {
            const dadosAPI = {
                empresa_id: dados.empresa_id,
                data_referencia: dados.data_referencia,
                qtd_almoco_solicitado: dados.qtd_almoco_solicitado || 0,
                qtd_almoco_servido: dados.qtd_almoco_servido || 0,
                qtd_lanches_solicitado: dados.qtd_lanches_solicitado || 0,
                qtd_lanches_servido: dados.qtd_lanches_servido || 0,
                qtd_lanches_sexta_solicitado: dados.qtd_lanches_sexta_solicitado || 0,
                qtd_lanches_sexta_servido: dados.qtd_lanches_sexta_servido || 0,
                qtd_almoco_he_solicitado: dados.qtd_almoco_he_solicitado || 0,
                // Sem servido no payload o backend mantém o valor já gravado na linha.
                ...(dados.qtd_almoco_he_servido !== undefined && {
                    qtd_almoco_he_servido: dados.qtd_almoco_he_servido,
                }),
                valor_unitario: dados.valor_unitario || 15.0,
                observacoes: dados.observacoes || '',
                usuario_cadastro: dados.usuario_cadastro || 'sistema',
            };
            const response = await api.post('/api/recepcao/almocos-diario', dadosAPI);
            return response.data;
        }
        catch (error) {
            console.error('Erro ao cadastrar almoço diário:', error);
            if (axios.isAxiosError(error) && error.response?.data)
                return error.response.data;
            throw error;
        }
    },
    async registrarExportacaoAlmocosDiario(dados) {
        const response = await api.post('/api/recepcao/almocos-diario/registrar-exportacao', dados);
        return response.data;
    },
    async listarFechamentos(params = {}) {
        try {
            const queryParams = new URLSearchParams();
            if (params.data_de)
                queryParams.append('data_inicio', params.data_de);
            if (params.data_ate)
                queryParams.append('data_fim', params.data_ate);
            if (params.empresa)
                queryParams.append('empresa', params.empresa);
            if (params.valor_almoco)
                queryParams.append('valor_almoco', params.valor_almoco.toString());
            if (params.valor_lanche)
                queryParams.append('valor_lanche', params.valor_lanche.toString());
            const url = `/api/recepcao/fechamentos${queryParams.toString() ? '?' + queryParams.toString() : ''}`;
            const response = await api.get(url);
            return response.data;
        }
        catch (error) {
            console.error('Erro ao listar fechamentos:', error);
            if (axios.isAxiosError(error) && error.response?.data)
                return error.response.data;
            throw error;
        }
    },
    async listarFechamentosRefeicoes(params = {}) {
        try {
            const queryParams = new URLSearchParams();
            if (params.empresa)
                queryParams.append('empresa', params.empresa);
            if (params.data_inicio)
                queryParams.append('data_inicio', params.data_inicio);
            if (params.data_fim)
                queryParams.append('data_fim', params.data_fim);
            if (params.tipo_refeicao)
                queryParams.append('tipo_refeicao', params.tipo_refeicao);
            if (params.status)
                queryParams.append('status', params.status);
            if (params.incluir_individuais)
                queryParams.append('incluir_individuais', 'true');
            const url = `/api/recepcao/fechamentos-refeicoes${queryParams.toString() ? '?' + queryParams.toString() : ''}`;
            const response = await api.get(url);
            return response.data;
        }
        catch (error) {
            console.error('Erro ao listar fechamentos de refeições:', error);
            if (axios.isAxiosError(error) && error.response?.data)
                return error.response.data;
            throw error;
        }
    },
    async criarFechamentoRefeicao(dados) {
        try {
            const response = await api.post('/api/recepcao/fechamentos-refeicoes', dados);
            return response.data;
        }
        catch (error) {
            console.error('❌ Erro ao criar fechamento de refeição:', error);
            if (axios.isAxiosError(error) && error.response?.data) {
                console.error('📄 Resposta do servidor:', error.response.data);
                return error.response.data;
            }
            throw error;
        }
    },
    async atualizarFechamentoRefeicao(id, dados) {
        try {
            const response = await api.put(`/api/recepcao/fechamentos-refeicoes/${id}`, dados);
            return response.data;
        }
        catch (error) {
            console.error('Erro ao atualizar fechamento de refeição:', error);
            if (axios.isAxiosError(error) && error.response?.data)
                return error.response.data;
            throw error;
        }
    },
    async excluirFechamentoRefeicao(id) {
        try {
            const response = await api.delete(`/api/recepcao/fechamentos-refeicoes/${id}`);
            return response.data;
        }
        catch (error) {
            console.error('Erro ao excluir fechamento de refeição:', error);
            if (axios.isAxiosError(error) && error.response?.data)
                return error.response.data;
            throw error;
        }
    },
    async atualizarStatusFechamento(id, status) {
        try {
            const response = await api.put(`/api/recepcao/fechamentos-refeicoes/${id}/status`, { status });
            return response.data;
        }
        catch (error) {
            console.error('Erro ao atualizar status do fechamento:', error);
            if (axios.isAxiosError(error) && error.response?.data)
                return error.response.data;
            throw error;
        }
    },
    async calcularFechamentoRefeicao(dados) {
        try {
            const response = await api.post('/api/recepcao/fechamentos-refeicoes/calcular', dados);
            return response.data;
        }
        catch (error) {
            console.error('Erro ao calcular fechamento de refeição:', error);
            if (axios.isAxiosError(error) && error.response?.data)
                return error.response.data;
            throw error;
        }
    },
    async buscarResumoSolicitacoesRefeicoes(params = {}) {
        try {
            const queryParams = new URLSearchParams();
            if (params.data_inicio)
                queryParams.append('data_inicio', params.data_inicio);
            if (params.data_fim)
                queryParams.append('data_fim', params.data_fim);
            if (params.tipo_refeicao)
                queryParams.append('tipo_refeicao', params.tipo_refeicao);
            const url = `/api/recepcao/solicitacoes-refeicoes/resumo${queryParams.toString() ? '?' + queryParams.toString() : ''}`;
            const response = await api.get(url);
            return response.data;
        }
        catch (error) {
            console.error('Erro ao buscar resumo de solicitações de refeições:', error);
            if (axios.isAxiosError(error) && error.response?.data)
                return error.response.data;
            throw error;
        }
    },
    async buscarDetalhesSolicitacoesRefeicoes(params = {}) {
        try {
            const queryParams = new URLSearchParams();
            if (params.empresa)
                queryParams.append('empresa', params.empresa);
            if (params.tipo_refeicao)
                queryParams.append('tipo_refeicao', params.tipo_refeicao);
            if (params.data_inicio)
                queryParams.append('data_inicio', params.data_inicio);
            if (params.data_fim)
                queryParams.append('data_fim', params.data_fim);
            if (params.modo_fechamento !== undefined)
                queryParams.append('modo_fechamento', params.modo_fechamento.toString());
            const url = `/api/recepcao/solicitacoes-refeicoes/detalhes${queryParams.toString() ? '?' + queryParams.toString() : ''}`;
            const response = await api.get(url);
            return response.data;
        }
        catch (error) {
            console.error('Erro ao buscar detalhes de solicitações de refeições:', error);
            if (axios.isAxiosError(error) && error.response?.data)
                return error.response.data;
            throw error;
        }
    },
    async gerarRelatorioDetalhado(params = {}) {
        try {
            const queryParams = new URLSearchParams();
            if (params.data_de)
                queryParams.append('data_de', params.data_de);
            if (params.data_ate)
                queryParams.append('data_ate', params.data_ate);
            if (params.valor_almoco)
                queryParams.append('valor_almoco', params.valor_almoco.toString());
            if (params.valor_lanche)
                queryParams.append('valor_lanche', params.valor_lanche.toString());
            if (params.empresa)
                queryParams.append('empresa', params.empresa);
            const url = `/api/recepcao/relatorio-detalhado${queryParams.toString() ? '?' + queryParams.toString() : ''}`;
            const response = await api.get(url);
            return response.data;
        }
        catch (error) {
            console.error('Erro ao gerar relatório detalhado:', error);
            if (axios.isAxiosError(error) && error.response?.data)
                return error.response.data;
            throw error;
        }
    },
    async editarAlmocoDiario(almocoId, dados) {
        try {
            const response = await api.put(`/api/recepcao/almocos-diario/${almocoId}`, dados);
            return response.data;
        }
        catch (error) {
            console.error('Erro ao editar almoço diário:', error);
            if (axios.isAxiosError(error) && error.response?.data)
                return error.response.data;
            throw error;
        }
    },
    async excluirAlmocoDiario(almocoId) {
        try {
            const response = await api.delete(`/api/recepcao/almocos-diario/${almocoId}`);
            return response.data;
        }
        catch (error) {
            console.error('Erro ao excluir almoço diário:', error);
            if (axios.isAxiosError(error) && error.response?.data)
                return error.response.data;
            throw error;
        }
    },
    async salvarValoresRefeicoes(colaboradores) {
        try {
            const response = await api.post('/api/recepcao/solicitacoes-refeicoes/salvar-valores', {
                colaboradores,
            });
            return response.data;
        }
        catch (error) {
            console.error('Erro ao salvar valores de refeições:', error);
            if (axios.isAxiosError(error) && error.response?.data)
                return error.response.data;
            throw error;
        }
    },
};
